module.exports = __webpack_public_path__ + "tf.f98f3dc2697f3f29aa3d.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/tf.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/tf.svg
// module chunks = styles